module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isFormModal) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeForm
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "menu_list"
  }, [_c('li', {
    staticClass: "menu_item",
    class: {
      'active': _vm.activeTab == 'user'
    },
    on: {
      "click": function($event) {
        _vm.selectTab('user')
      }
    }
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('li', {
    staticClass: "menu_item",
    class: {
      'active': _vm.activeTab == 'worker'
    },
    on: {
      "click": function($event) {
        _vm.selectTab('worker')
      }
    }
  }, [_vm._v("Врачи")]), _vm._v(" "), _c('li', {
    staticClass: "menu_item",
    class: {
      'active': _vm.activeTab == 'clinic'
    },
    on: {
      "click": function($event) {
        _vm.selectTab('clinic')
      }
    }
  }, [_vm._v("Клиники")]), _vm._v(" "), _c('li', {
    staticClass: "menu_item",
    class: {
      'active': _vm.activeTab == 'specialization'
    },
    on: {
      "click": function($event) {
        _vm.selectTab('specialization')
      }
    }
  }, [_vm._v("\n\t\t\t\tСпециализации\n\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "menu_item",
    class: {
      'active': _vm.activeTab == 'role'
    },
    on: {
      "click": function($event) {
        _vm.selectTab('role')
      }
    }
  }, [_vm._v("Роли")])])]), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "filter_field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterField),
      expression: "filterField"
    }],
    attrs: {
      "title": "filter of list",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filterField)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterField = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "create"
  }, [_c('button', {
    staticClass: "styled_button add_instance",
    on: {
      "click": _vm.addInstance
    }
  }, [_vm._v("Добавить")])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, _vm._l((_vm.filteredList), function(instance, index) {
    return _c('div', {
      staticClass: "table_row",
      class: {
        'even': index % 2 === 0
      }
    }, [(_vm.activeTab == 'user') ? _c('div', {
      staticClass: "name",
      on: {
        "click": function($event) {
          _vm.editInstance(instance, _vm.activeTab)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(instance.first_name) + " " + _vm._s(instance.last_name) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'worker') ? _c('div', {
      staticClass: "name",
      on: {
        "click": function($event) {
          _vm.editInstance(instance, _vm.activeTab)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(instance.user_first_name) + " " + _vm._s(instance.user_last_name) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'clinic') ? _c('div', {
      staticClass: "name",
      on: {
        "click": function($event) {
          _vm.editInstance(instance, _vm.activeTab)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(instance.name) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'specialization') ? _c('div', {
      staticClass: "name",
      on: {
        "click": function($event) {
          _vm.editInstance(instance, _vm.activeTab)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(instance.name) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'role') ? _c('div', {
      staticClass: "name",
      on: {
        "click": function($event) {
          _vm.editInstance(instance, _vm.activeTab)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(instance.name) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "styled_button remove",
      on: {
        "click": function($event) {
          _vm.removeInstance(instance)
        }
      }
    }, [_vm._v("Удалить")])])
  })), _vm._v(" "), (_vm.isFormModal) ? _c('div', {
    staticClass: "formModal"
  }, [_c('div', {
    staticClass: "form_body"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.activeTab))]), _vm._v(" "), _c(_vm.instanceForm, {
    tag: "div",
    staticClass: "component",
    attrs: {
      "model": _vm.instanceData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    staticClass: "styled_button",
    on: {
      "click": _vm.updateInstance
    }
  }, [_vm._v("Обновить")]), _vm._v(" "), _c('button', {
    staticClass: "styled_button",
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("Закрыть")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    staticClass: "styled_button prev_page",
    attrs: {
      "disabled": _vm.paginationData.current_page < 2
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_vm._v("\n\t\t\t\tНазад\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page_number"
  }, [_vm._v(_vm._s(_vm.paginationData.current_page) + " из " + _vm._s(_vm.paginationData.last_page))]), _vm._v(" "), _c('button', {
    staticClass: "styled_button next_page",
    attrs: {
      "disabled": _vm.paginationData.to === _vm.paginationData.total
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("Вперед\n\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51949056"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin panel/Admin panel.vue
// module id = 614
// module chunks = 0